/* eslint-disable no-unused-expressions, @typescript-eslint/no-unused-expressions */
import React, { useEffect, useRef } from 'react';

// clsx
import clsx from 'clsx';

// Styles
import useStyles from './horizontalScroll.styles';

interface HorizontalProps {
  children: React.ReactElement | React.ReactNode;
  scrollbar?: boolean;
  classes?: {
    content?: string;
    scrollbar?: string;
  };
}

const HorizontalScroll: React.FC<HorizontalProps> = ({
  children,
  scrollbar,
  classes,
}) => {
  const classesDefault = useStyles();
  const sliderRef = useRef<HTMLDivElement>(null);

  const scrollHorizontal = () => {
    const slider = sliderRef.current;
    let isDown = false;
    let startX: number;
    let scrollLeft: number;

    slider?.addEventListener('mousedown', (e: MouseEvent) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider?.addEventListener('mouseup', () => {
      isDown = false;
    });

    slider?.addEventListener('mouseleave', () => {
      isDown = false;
    });

    slider?.addEventListener('mousemove', (e: MouseEvent) => {
      if (!isDown) return;

      e.preventDefault();

      const x = e.pageX - slider.offsetLeft;
      const walk = x - startX;
      slider.scrollLeft = scrollLeft - walk;
    });
  };

  useEffect(() => {
    scrollHorizontal();
  }, []);

  return (
    <div className={classesDefault.container}>
      <div
        ref={sliderRef}
        className={clsx(
          classesDefault.content,
          classes?.content,
          classes?.scrollbar,
          {
            [classesDefault.visibleScrollbar]: scrollbar,
            [classesDefault.hiddenScrollbar]: !scrollbar,
          },
        )}>
        {children}
      </div>
    </div>
  );
};

export default HorizontalScroll;
export { HorizontalScroll };
